import authBg from './auth-sidebar-bg.svg';
import logo from './logo.png';
import logoFullDark from './logo-full-dark.svg';

export default { authBg, logo, logoFullDark };
